































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import EventBus from "../event-bus";

@Component({
  filters: {
    moment: function(timestamp: number) {
      return moment.unix(timestamp).format("DD/MM/YYYY HH:mm");
    }
  }
})
export default class Warning extends Vue {
  @Prop()
  message: any;

  @Prop()
  type: any;

  showAdditionaData: boolean = false;

  PromoteToEmergency(message: any) {
    EventBus.$emit("show-emergency-popup", message);
  }

  AssociateToEmergency(message: any) {
    EventBus.$emit("choose-emergency-popup", message);
  }


  centerOnMap(message: any) {
    if (message.coordinates && message.coordinates[0])
      EventBus.$emit("display-on-map", message);
  }

  async toggleWarning(message: any) {
    try {
      let resp = await this.$http.patch(`/emma/admin/warnings/${message.id}`);
      if (resp.data.success)
        message.status = message.status == "active" ? "inactive" : "active";
    } catch (e) {}
  }

  showLightbox(image: string) {
    EventBus.$emit("show-lightbox", image);
  }

  onlyImages(filenames: Array<string>) {
    return filenames.filter((elem: string) => {
      const ext = elem.split(".").pop() || "";
      return ["jpg", "png"].includes(ext);
    });
  }

  onlym4a(filenames: Array<string>) {
    return filenames.filter((elem: string) => {
      const ext = elem.split(".").pop() || "";
      return ["m4a"].includes(ext);
    });
  }

  only3gp(filenames: Array<string>) {
    return filenames.filter((elem: string) => {
      const ext = elem.split(".").pop() || "";
      return ["3gp"].includes(ext);
    });
  }
}
